import React from 'react';
import { Redirect } from 'react-router';
import { ActionBar } from '@/components/atoms/ActionBar';
import { Button } from '@/components/atoms/Button';
import { FormattedMessage } from 'react-intl';
import DeleteModal from '@/components/atoms/DeleteModal/DeleteModal';
import ErrorMessage from '@/components/atoms/ErrorMessage';
import { Routes } from '@/core/router/routes.types';
import { stringifyError } from '@/utils/errors';
import { ConfigContainer } from '@/pages/Config/common/style/Common.style';
import WebhookPanel from '@/pages/Config/Webhooks/WebhookPanel';
import BrandWebhookConfigurationPanel from '@/components/organisms/Webhook/BrandWebhookConfigurationPanel';
import Loader from '@/components/atoms/Loader';
import { useEditBrandWebhookVM } from './EditBrandWebhook.viewmodel';

const EditBrandWebhook: React.FunctionComponent<React.PropsWithChildren> = () => {
    const {
        theme,
        formRef,
        isValid,
        setValid,
        isDirty,
        setDirty,
        isDelete,
        setDelete,
        externalWebhook,
        isDataLoading,
        isPutLoading,
        putError,
        isDeleteLoading,
        deleteError,
        onDelete,
        onSave,
        shouldRedirect,
    } = useEditBrandWebhookVM();

    if (isDataLoading) {
        return <Loader color={theme.color.primary} size={40} withContainer />;
    }

    if (shouldRedirect) {
        return <Redirect to={Routes.NotFound} />;
    }

    return (
        <>
            <ConfigContainer>
                <WebhookPanel isBrandLevel={true} />
                <BrandWebhookConfigurationPanel
                    ref={formRef}
                    webhook={externalWebhook}
                    setValid={setValid}
                    setDirty={setDirty}
                />
            </ConfigContainer>

            <ActionBar error={stringifyError(putError)}>
                <Button buttonType="red" onClick={() => setDelete(true)}>
                    <FormattedMessage id="button.delete" />
                </Button>

                <Button buttonType="primary" onClick={onSave} isLoading={isPutLoading} disabled={!isValid || !isDirty}>
                    <FormattedMessage id="button.save" />
                </Button>
            </ActionBar>
            <DeleteModal
                title="webhook.modal.warning"
                description="webhook.modal.confirmDelete"
                isOpen={isDelete}
                onHide={() => setDelete(false)}
                onSubmit={onDelete}
                isLoading={isDeleteLoading}
            >
                {deleteError ? <ErrorMessage>{stringifyError(deleteError)}</ErrorMessage> : null}
            </DeleteModal>
        </>
    );
};

export default EditBrandWebhook;
